import Vue from 'vue'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll, { componentName: 'seamlessScroll' })
